import { Link } from "wouter";
import { useUsageSnapshot } from "@/lib/usageGate";
import { wouldMark } from "@/lib/trialMark";

/**
 * Said BEFORE converting: on a trial use, a finished PDF carries a small "Created with FreeDailyPro.com"
 * badge in the bottom right corner of each page (what trialMark.ts really draws). Shown only when this tool's PDF would really be stamped (trial session, tool not exempt), so it
 * never promises a mark that will not appear. After conversion the download button repeats it.
 */
export function TrialFooterNotice({ toolId, what = "The PDF" }: { toolId: string; what?: string }) {
  useUsageSnapshot(); // re-render once the trial/paid state is known
  if (!wouldMark("application/pdf", "output.pdf", toolId)) return null;
  return (
    <p className="text-xs text-muted-foreground" data-testid="trial-footer-notice">
      Trial uses: {what} gets a small “Created with FreeDailyPro.com” badge in the bottom right corner of each page.{" "}
      <Link href="/pricing" className="underline underline-offset-2 hover:text-foreground">Go paid to avoid it</Link>.
    </p>
  );
}
